import { render, staticRenderFns } from "./page-prompt-jira-connect.vue?vue&type=template&id=2c702369&scoped=true&"
import script from "./page-prompt-jira-connect.vue?vue&type=script&lang=js&"
export * from "./page-prompt-jira-connect.vue?vue&type=script&lang=js&"
import style0 from "./page-prompt-jira-connect.vue?vue&type=style&index=0&id=2c702369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c702369",
  null
  
)

export default component.exports